import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { TitledCard } from 'Components';
import { SelectField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import { IMPORT_ITEMS_FORM_NAME } from 'Common/FormEnum';
import { Dropzone } from 'Components/forms/Dropzone';
import { yesNoOptions } from './../../../helper/importExport';

const FileConfigurationComponent = props => {
  const {
    displayDropZone,
    fileFormatOptions,
    delimiterButtonOptions,
    onDrop,
  } = props;
  return (
    <TitledCard title={'File Configuration Settings'}>
      <Grid>
        <Grid.Row className="row--compressed" columns={2}>
          <Grid.Column>
            <Grid style={{ marginTop: '1rem' }}>
              <Grid.Row>
                <Grid.Column>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={6} verticalAlign={'middle'}>
                        <Field
                          name={ImportExportItemsEnum.FileFormat}
                          component={SelectField}
                          type={'text'}
                          options={fileFormatOptions}
                          label={'File Format'}
                          disabled={true}
                        />
                      </Grid.Column>
                      <Grid.Column width={10} verticalAlign={'bottom'}>
                        <Button.Group basic className="btn-group--active-group">
                          <ReduxFormButtonGroup
                            options={delimiterButtonOptions}
                            type={'button'}
                            formName={IMPORT_ITEMS_FORM_NAME}
                            fieldName={ImportExportItemsEnum.Delimiter}
                          />
                        </Button.Group>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <div>
                    <label>Does the first row contain header information</label>
                    <ReduxFormButtonGroup
                      options={yesNoOptions}
                      type={'button'}
                      formName={IMPORT_ITEMS_FORM_NAME}
                      fieldName={ImportExportItemsEnum.IncludeHeaders}
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
          {displayDropZone && (
            <Grid.Column>
              <div>
                <label>Select CSV file</label>
                <Dropzone
                  accept=".csv,.txt"
                  activeClassName="file--dropzone--active"
                  className="file--dropzone"
                  multiple={false}
                  name={ImportExportItemsEnum.FileName}
                  onDrop={onDrop}
                >
                  <p>
                    Drag and drop the csv file here <br />
                    <small>or double click to select file</small>.
                  </p>
                </Dropzone>
              </div>
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </TitledCard>
  );
};
FileConfigurationComponent.propTypes = {
  displayDropZone: PropTypes.bool,
  fileFormatOptions: PropTypes.array.isRequired,
  delimiterButtonOptions: PropTypes.array.isRequired,
  containHeaderInformation: PropTypes.array,
  onDrop: PropTypes.func,
};

export default FileConfigurationComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/importInventory/components/FileConfiguration.js